import { UiKitLabelBase, UiKitLabelBaseProps } from '@/fo/ui/kit/label/base';

import { styles } from './UiKitLabelBrand.styles';

export interface UiKitLabelBrandProps
  extends Omit<UiKitLabelBaseProps, 'as' | 'color'> {
  color?: string;
  url?: string;
}

export function UiKitLabelBrand({
  children,
  color,
  size,
  className,
  url
}: UiKitLabelBrandProps) {
  const slots = styles();

  return url ? (
    <UiKitLabelBase
      as="link"
      href={url}
      size={size}
      className={slots.base({
        className: [className, size ? '' : 'px-2 tracking-normal md:px-3']
      })}
      customColor={color ? color : 'black'}
      uppercase
    >
      {children}
    </UiKitLabelBase>
  ) : (
    <UiKitLabelBase
      as="div"
      size={size}
      className={slots.base({
        className: [
          className,
          size ? '' : 'cursor-default px-2 tracking-normal md:px-3'
        ]
      })}
      customColor={color ? color : 'black'}
      uppercase
    >
      {children}
    </UiKitLabelBase>
  );
}
